import { AllExpenses } from "../../api/services/allExpenses";
import { fetchExpenses, fetchExpensesByProjectIdReducer } from "./expenseSlice";

// export const fetchAllExpenses = ({ userRole, projectId }) => async (dispatch) => {
//     try {
//         const data = await AllExpenses({ userRole, projectId });
//         if (data) {
//             dispatch(fetchExpenses(data));
//         }
//     } catch (error) {
//         console.error("Error fetching expenses:", error);
//     }
// };

// export const expensesByProjectIdAction = ({ userRole, projectId }) => async (dispatch) => {
//     try {
//         const data = await fetchExpensesByProjectId({ userRole, projectId })        
//         if(data){
//             dispatch(fetchExpensesByProjectIdReducer(data))
//         }
//     } catch (error) {
//                 console.error("Error fetching expenses:", error);
//     }

// }


export const fetchAllExpenses = ({ userRole, projectId, currencyView }) => async (dispatch) => {
  try {
    const data = await AllExpenses({ userRole, projectId, currencyView });
    if (data) {
      if (projectId) {
        dispatch(fetchExpensesByProjectIdReducer(data));
      } else {
        dispatch(fetchExpenses(data));
      }
    }
  } catch (error) {
    console.error("Error fetching expenses:", error);
  }
};
